export default function () {
    return {
        drawerOpen: false,
        productsLoading: false,
        totalsLoading: false
    }
}
  